import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/(use-page-wrapper)/(main-nav)/availability/skeleton.tsx");
